const TENANT_COOKIE_NAME = 'x-tenant-id';

/**
 * Get the selected tenant ID from cookie
 * Returns null if no tenant is stored
 */
export function getSelectedTenantId(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  try {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === TENANT_COOKIE_NAME) {
        return decodeURIComponent(value);
      }
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Set the selected tenant ID in cookie
 */
export function setSelectedTenantId(tenantId: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    // Set cookie with 30 day expiry, accessible to all paths
    const expires = new Date();
    expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `${TENANT_COOKIE_NAME}=${encodeURIComponent(tenantId)}; expires=${expires.toUTCString()}; path=/`;
  } catch {
    // Silently fail if cookies are not available
  }
}

/**
 * Clear the selected tenant ID from cookie
 */
export function clearSelectedTenantId(): void {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    // Set cookie with past expiry date to delete it
    document.cookie = `${TENANT_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  } catch {
    // Silently fail if cookies are not available
  }
}
